import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthFacade, Helper } from '@piqet-angular/data';
import { MustMatch } from '../register/must-match.validator';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-force-change-password',
  templateUrl: './force-change-password.component.html',
  styleUrls: ['./force-change-password.component.scss'],
})
export class ForceChangePasswordComponent implements OnDestroy {
  changePasswordForm!: FormGroup;
  specialCharactersflag: boolean = true;
  upperCaseCharactersflag: boolean = true;
  lowerCaseCharactersflag: boolean = true;
  fieldTextTypeNewPwd = false;
  fieldTextType = false;
  emailAddress: any;
  fieldTextTypeConfirmPwd = false;
  numberCharactersflag: boolean = true;
  minLengthsflag: boolean = true;
  isErrorpwd: boolean = false;
  submitted: boolean = true;
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public authFacade: AuthFacade
  ) {
    this.emailAddress = this.modal?.modalService?.config?.initialState?.['emailId'];
  }
  ngOnDestroy(): void {
    this.authFacade.passwordUpdated();
  }

  ngOnInit() {
    const pwdReg = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
    this.changePasswordForm = this.formBuilder.group(
      {
        oldPassword: ['', Validators.required],
        Password: [null, [Validators.required, Validators.pattern(pwdReg)]],
        ConfirmPassword: ['', Validators.required],
      },
      {
        validator: MustMatch('Password', 'ConfirmPassword'),
      }
    );
  }

  comparePasswords() {
    if (
      this.changePasswordForm.controls['oldPassword'].value ==
      this.changePasswordForm.controls['Password'].value
    ) {
      this.isErrorpwd = true;
      this.submitted = false;
    } else {
      this.isErrorpwd = false;
      this.submitted = true;
    }
  }

  onClose() {}

  validationsPassword() {
    this.comparePasswords();
    const isValidate = Helper.passwordValidatior(
      this.changePasswordForm.controls['Password'].value
    );
    this.upperCaseCharactersflag = isValidate.upperCaseCharactersflag;
    this.lowerCaseCharactersflag = isValidate.lowerCaseCharactersflag;
    this.numberCharactersflag = isValidate.numberCharactersflag;
    this.specialCharactersflag = isValidate.specialCharactersflag;
    this.minLengthsflag = isValidate.minLengthsflag;
  }

  toggleFieldOldPwd() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldNewPwd() {
    this.fieldTextTypeNewPwd = !this.fieldTextTypeNewPwd;
  }
  toggleFieldConfirmPwd() {
    this.fieldTextTypeConfirmPwd = !this.fieldTextTypeConfirmPwd;
  }

  submit() {
    if (!this.changePasswordForm.valid) {
      this.changePasswordForm.get('oldPassword')?.markAsTouched();
      this.changePasswordForm.get('Password')?.markAsTouched();
      this.changePasswordForm.get('ConfirmPassword')?.markAsTouched();
      return;
    }
    const data = {
      Email: this.emailAddress,
      OldPassword: this.changePasswordForm.controls['oldPassword'].value,
      Password: this.changePasswordForm.controls['Password'].value,
      PasswordRepeat: this.changePasswordForm.controls['ConfirmPassword'].value,
      isForcePassword: true,
    };
    this.authFacade.changePassword(data);
  }
}
